import AppModel from '../DataModel/AppModel';

// This module collects the logic of showing the pop up message boxes
// in the ui.

// Whenever a uiMessage is set with a delay for clearing it, this id should
// be set, to allow cancelling the timeout.
let uiMessageTimeoutId = null;

// Sets the uiMessage and makes it go away after a short while
function showTemporaryUIMessage(message) {
  clearUIMessage();
  AppModel.uiMessage = message;
  uiMessageTimeoutId = setTimeout(()=>{
    clearUIMessage();
  },AppModel.uiMessageDelay);
}
// Sets a uiMessage that has an UNDO action.
// Goes away after 2x the default time, and if clicked will perform the
// action.
function showTemporaryUndoMessage(message, action) {
  clearUIMessage();
  AppModel.uiMessage = message;
  AppModel.uiUndoAction=action;
  uiMessageTimeoutId = setTimeout( () => {
    clearUIMessage();
  }, AppModel.uiMessageDelay*2 );
}

// Before setting a new ui message, get rid of a potentially existing one:
function clearUIMessage() {
  if(!uiMessageTimeoutId) return;
  clearTimeout(uiMessageTimeoutId);
  AppModel.uiMessage=null;
  AppModel.uiUndoAction=null;
  uiMessageTimeoutId=null;
}

// Can be used to catch errors from server-operations
// Will display a pop up in the middle of the screen
// with an error message that the user will have to
// click to make go away.
function uiErrorDisplay(error) {
  if(!error.responseText) {
    AppModel.uiError="Operation failed.  Please report issue.";
  }
  else {
    AppModel.uiError=error.responseText;
  }
  throw new Error(error);
};

// The methods exported from this module
export {
  showTemporaryUIMessage,
  showTemporaryUndoMessage,
  uiErrorDisplay,
  clearUIMessage
}



/** WEBPACK FOOTER **
 ** ./src/utils/UIMessageBoxes.js
 **/